module.exports = __webpack_public_path__ + "media/images/magnet_men-2156c76a61949517f173b2a2a486d5f2.svg";